import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";
import {useState} from "react";

export const useUsunPozycjeSlownika = () => {
    const queryClient = useQueryClient()
    const [slownikData, setSlownikData] = useState(null)

    return useMutation({
        mutationFn: ({slownik, id}) => deleteItem(`/slowniki/${slownik}/${id}`),
        onMutate: ({slownik}) => {
            setSlownikData(slownik)
        },
        onError: () => {
            toast.error('Błąd podczas operacji')
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: [`pozycje_slownika__${slownikData}`]
            })
        },
        onSuccess: ({message}) => {
            toast.success(message)
        }
    })
}